'use strict';

/**
 * Method to pass data to Optimize so the event/data shows in the splunk warehouse
 *
 * @async
 * @param {String} eventName - Name of the event to emit to splunk
 * @param {Object} [payload] - Data to emit to splunk (Optional)
 */
var trackEvent;

trackEvent = function(eventName, payload) {
  if (payload == null) {
    payload = {};
  }
  requestIdleCallback(function() {
    var defaults, ref;
    defaults = {
      b: Cookie.get('b'),
      pageId: location.pathname
    };
    payload = Object.assign({}, payload, defaults);
    return typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null ? (ref = OptimizeSuite.TrackingHub) != null ? ref.add("" + eventName, payload) : void 0 : void 0;
  });
};

module.exports = trackEvent;

